import { Tooltip, Typography, Hidden } from '@material-ui/core';
import { createStyles, Theme, withStyles, WithStyles } from '@material-ui/core/styles';
import { OpenInBrowser } from '@material-ui/icons';
import clsx from 'clsx';
import * as i18next from 'i18next';
import Link from 'next/link';
import * as React from 'react';

import Context from '../contexts';

const styles = (theme: Theme) =>
  createStyles({
    alignRight: {
      textAlign: 'right',
    },
    light: {
      color: theme.palette.getContrastText('#fff'),
    },
    dark: {
      color: theme.palette.getContrastText(theme.palette.primary.main),
    },
    text: {
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      textTransform: 'uppercase',
      overflow: 'hidden',
      fontWeight: 'bold',
      cursor: 'pointer',
      ':& a': {
        textDecoration: 'none',
        color: 'white',
        cursor: 'pointer',
      },
    },
    loggedInInfo: {
      lineHeight: '100%',
    },
    linkContainer: {
      display: 'flex',
      alignItems: 'center',
      '& > svg': {
        paddingRight: theme.spacing(0.5),
      },
    },
  });

interface Properties extends WithStyles<typeof styles> {
  className?: string;
  backgroundTone?: 'dark' | 'light' | undefined;
  alignRight?: boolean;
  t: i18next.TFunction;
}

const LineInfo = ({ classes, className, backgroundTone, alignRight, t }: Properties) => {
  const tone = backgroundTone || 'dark';

  return (
    <Context.LineDescription.Consumer>
      {(lineInfo: any) => {
        if (lineInfo.lineDescription) {
          return (
            <div>
              <Typography
                variant={'body2'}
                className={clsx(
                  className,
                  classes.loggedInInfo,
                  classes[tone],
                  classes.text,
                  alignRight && classes.alignRight,
                )}
              >
                <Link href={lineInfo.lineUrl}>
                  <Tooltip title={t(['shared:openLine'], { defaultValue: 'Open line' })!}>
                    <span className={classes.linkContainer}>
                      <OpenInBrowser />
                      <Hidden smDown>{lineInfo.lineDescription}</Hidden>
                    </span>
                  </Tooltip>
                </Link>
              </Typography>
            </div>
          );
        }
      }}
    </Context.LineDescription.Consumer>
  );
};

export default withStyles(styles)(LineInfo);
